var React = require('react');

function FaxInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M5 1a2 2 0 0 0-2 2v1h10V3a2 2 0 0 0-2-2H5z","key":0}),React.createElement("path",{"fillRule":"evenodd","d":"M11 9H5a1 1 0 0 0-1 1v3a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1v-3a1 1 0 0 0-1-1z","key":1}),React.createElement("path",{"fillRule":"evenodd","d":"M0 7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2h-1v-2a2 2 0 0 0-2-2H5a2 2 0 0 0-2 2v2H2a2 2 0 0 1-2-2V7zm2.5 1a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1z","key":2})]);
}

FaxInline.defaultProps = {"width":"16","height":"16","fill":"currentColor","className":"bi bi-printer-fill mx-1","viewBox":"0 0 16 16"};

module.exports = FaxInline;

FaxInline.default = FaxInline;
